<div
    class="dashboard-card dashboard-card-padding"
    [class.fullscreen]="isFullscreen"
    [style.top.px]="isFullscreen ? fullscreenBox?.top : null"
    [style.left.px]="isFullscreen ? fullscreenBox?.left : null"
    [style.width.px]="isFullscreen ? fullscreenBox?.width : null"
    [style.height.px]="isFullscreen ? fullscreenBox?.height : null"
    (window:keydown.escape)="deactivateFullscreen()"
>
    <div class="dashboard-card-header">
        <div class="header-main">
            <div *ngIf="canShowCardTitle()" class="dashboard-card-title">
                {{ getCardTitle() }}

                <span
                    *ngIf="dashboardItem.chartDocumentation"
                    class="chart-documentation"
                    nz-icon
                    nzType="info-circle"
                    nzTheme="outline"
                    (click)="showChartDocumentation()"
                ></span>
            </div>
            <div *ngIf="canShowCardSubTitle()" class="dashboard-card-subtitle">
                {{ getCardSubTitle() }}
            </div>
        </div>
        <!-- <div #emptyTitle class="dashboard-card-title"></div> -->
        <div class="header-toolbar">
            <button
                *ngIf="showErrorIcon"
                nz-button
                nz-tooltip
                [nzTooltipTitle]="dataLoaderResult.statusMessage"
                (click)="copyStatusMessage()"
                z-index="100"
            >
                <span nz-icon nzType="warning" nzTheme="outline"></span>
            </button>

            <button
                nz-button
                nzPlacement="bottomRight"
                (click)="
                    isFullscreen ? deactivateFullscreen() : activateFullscreen()
                "
            >
                <span
                    nz-icon
                    [nzType]="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
                ></span>
            </button>

            <button
                nz-button
                nz-dropdown
                [nzDropdownMenu]="menu"
                nzPlacement="bottomRight"
            >
                <span nz-icon nzType="ellipsis"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu *ngIf="isLocalhost()">
                    <li nz-menu-item (click)="showLoading()">Show loading</li>
                    <li nz-menu-item (click)="changeDatasetTo2dArray()">
                        Change Dataset format
                    </li>
                    <li nz-menu-item (click)="restoreOriginalDataset()">
                        Restore original dataset
                    </li>
                    <li nz-menu-item (click)="copyOption()">
                        Copy option to clipboard
                    </li>
                </ul>
                <ul nz-menu>
                    <li
                        *ngIf="canShowToggleChartType()"
                        nz-menu-item
                        (click)="toggleChartType()"
                    >
                        <span
                            nz-icon
                            [nzType]="menuItemToggleChartTypeIcon"
                            nzTheme="outline"
                        ></span
                        >{{ menuItemToggleChartTypeTitle$ | async }}
                    </li>
                    <li
                        nz-menu-item
                        *ngIf="canShowToggleSeriesType()"
                        style="width: 100%"
                    >
                        <nz-radio-group
                            [(ngModel)]="seriesType"
                            (ngModelChange)="onSeriesTypeChange($event)"
                            nzButtonStyle="solid"
                            nzSize="small"
                            [nzDisabled]="!(isActiveEchartsView$ | async)"
                        >
                            <label nz-radio-button nzValue="line">Line</label>
                            <label nz-radio-button nzValue="bar">Bar</label>
                        </nz-radio-group>
                    </li>
                    <li nz-menu-item *ngIf="canShowToggleStackingMode()">
                        <nz-radio-group
                            [(ngModel)]="stackingMode"
                            (ngModelChange)="onStackedValueChange($event)"
                            nzButtonStyle="solid"
                            nzSize="small"
                            [nzDisabled]="!(isActiveEchartsView$ | async)"
                        >
                            <label nz-radio-button nzValue="none">None</label>
                            <label nz-radio-button nzValue="stacked"
                                >Stacked</label
                            >
                            <label nz-radio-button nzValue="normalized"
                                >Normalized</label
                            >
                        </nz-radio-group>
                    </li>
                    <li
                        *ngIf="canShowExportDataToCSV()"
                        nz-menu-item
                        (click)="exportVisibleDataToCSV()"
                    >
                        <span nz-icon nzType="download" nzTheme="outline"></span
                        >Export to csv
                    </li>
                    <li
                        *ngIf="canShowExportDataToXLSX()"
                        nz-menu-item
                        (click)="exportVisibleDataToXLSX()"
                    >
                        <span
                            nz-icon
                            nzType="file-excel"
                            nzTheme="outline"
                        ></span
                        >Export to Excel
                    </li>
                    <li nz-menu-item (click)="exportVisibleDataToClipboard()">
                        <span nz-icon nzType="copy" nzTheme="outline"></span
                        >Copy data to clipboard
                    </li>
                    <!-- <li
                        nz-menu-item
                        [nzDisabled]="copySQLDisabled"
                        (click)="copySQLToCliboard()"
                        [cdkCopyToClipboard]="
                            dataLoaderResult.sqlAndJsProcessing
                        "
                    >
                        Copy SQL<span nz-icon nzType="copy"></span>
                    </li> -->
                </ul>
            </nz-dropdown-menu>
        </div>
    </div>
    <div class="dashboard-card-body">
        <div *ngIf="showErrorOverlay" class="chart-overlay">
            <div class="error-container">
                <h2 class="error-title">{{ errorTitle }}</h2>
                <p class="error-message">{{ errorMessage }}</p>
            </div>
        </div>

        <!-- prettier-ignore -->
        <div
            [ngClass]="{
                'echarts-container-800': chartHeight == '800',
                'echarts-container-600': chartHeight == '600',
                'echarts-container-400': chartHeight == '400',
                'echarts-container-100': chartHeight == '100',
                'echarts-container-50': chartHeight == '50',
                'echarts-container': true,
                'hidden-echarts': !(isActiveEchartsView$ | async)
            }"
            echarts
            (chartInit)="onChartInit($event)"
            [options]="echartsOption"
            [autoResize]="true"
            [initOpts]="echartsInitOpts"
        ></div>

        <div
            *ngIf="!(isActiveEchartsView$ | async)"
            style="max-height: 190px; overflow-y: auto; overflow-x: auto"
        >
            <app-table-view [data]="pivotData$"></app-table-view>
        </div>
    </div>
</div>
